import moment from 'moment'
import formatMoney from 'accounting-js/lib/formatMoney.js'
import Vue from 'vue'

import store from '@/store'
import allCurrencies from '@/config/currencies'
import { convertCurrency } from '@/components/CurrencyConverter'

const urlParser = document.createElement('a')

function getDefaultCurrency () {
  return store.getters['organizations/currentOrganization'].settings.defaultCurrency || 'USD'
}

export function domain (url) {
  urlParser.href = url
  return urlParser.hostname
}

export function count (arr) {
  if (arr) {
    return arr.length
  } else {
    return 0
  }
}

export function fmtDate (date,
  {
    fmt = store.getters['user/preferences'].dateFormat || 'D MMM YYYY'
  } = {}) {
  return date ? moment.utc(date).format(fmt) : null
}

export function pluralize (time, label) {
  if (time === 1) {
    return time + label
  }

  return time + label + 's'
}

function nFormatter (number) {
  const sign = Math.sign(number)
  const num = Math.abs(number)

  if (num === 0) {
    return [ num, '' ]
  }

  const si = [
    { value: 1, symbol: '' },
    { value: 1E3, symbol: 'K' },
    { value: 1E6, symbol: 'M' },
    { value: 1E9, symbol: 'G' },
    { value: 1E12, symbol: 'T' },
    { value: 1E15, symbol: 'P' },
    { value: 1E18, symbol: 'E' }
  ]

  for (let i = si.length - 1; i >= 0; i--) {
    if (num >= si[i].value) {
      return [ (num / si[i].value) * sign, `<sup>${si[i].symbol}</sup>` ]
    }
  }
}

// Currency formatting
export function fmtCurrency (
  number = 0,
  {
    currency = getDefaultCurrency(),
    format = store.getters['user/preferences'].currencyFormat || [0, '.', ','],
    avg = false
  } = {}) {
  let amount = parseFloat(number) || 0
  let currencyFinal = currency

  if (store.getters['user/preferences'].currencyConversion) {
    amount = convertCurrency(amount, store.getters['user/preferences'].currencyConversion)
    currencyFinal = store.getters['user/preferences'].currencyConversion
  }

  let mag = ''
  if (avg) {
    [amount, mag] = nFormatter(amount)
  }

  const symbol = allCurrencies[currencyFinal] || currencyFinal
  return formatMoney(amount, {
    symbol,
    precision: format[0],
    thousand: format[1],
    decimal: format[2]
  }) + mag
}

export function fmtNumber (number = 0,
  {
    locale = (store.getters['user/preferences'].currencyFormat ||
          navigator.language || navigator.userLanguage),
    fractionDigits = 0
  } = {}) {
  return parseFloat(number).toLocaleString(
    locale, {
      style: 'decimal',
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits
    }
  )
}

export function fmtPercentage (number = 0,
  {
    locale = (store.getters['user/preferences'].currencyFormat ||
          navigator.language || navigator.userLanguage),
    fractionDigits = 0
  } = {}) {
  return parseFloat(number).toLocaleString(
    locale, {
      style: 'percent',
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits
    }
  )
}

export function fmtFromNow (from) {
  return moment(from).fromNow()
}

export function fmtDateDiff (from, to = new Date()) {
  let diff = moment.duration(moment.utc(from).diff(to))

  if (diff !== 0) {
    return diff.humanize()
  } else {
    return null
  }
}

export function fmtDatesInterval (startDate, dueDate) {
  let _start
  let _end

  if (startDate) {
    _start = moment(startDate)
  }

  if (dueDate) {
    _end = moment(dueDate)
  }

  if (_start && !_end) {
    return _start.format('D MMM YYYY')
  } else if (_end && !_start) {
    return _end.format('D MMM YYYY')
  } else if (!_start && !_end) {
    return null
  }

  let ret = _end.format('D MMM YYYY')

  if (!_end || _start.isSame(_end, 'day')) {
    return ret
  } else {
    ret = `/ ${ret}`
  }

  if (_start.year() !== _end.year()) {
    ret = `${_start.year()} ${ret}`
  }

  if (_start.month() !== _end.month()) {
    ret = `${_start.format('MMM')} ${ret}`
  }

  ret = `${_start.date()} ${ret}`

  return ret
}

export function getFilterForType (type = 'number') {
  return filtersMap[type]
}

const filtersMap = {
  currency: fmtCurrency,
  date: fmtDate,
  percentage: fmtPercentage,
  number: fmtNumber
}

Vue.filter('count', count)
Vue.filter('domain', domain)
Vue.filter('fmtDate', fmtDate)
Vue.filter('pluralize', pluralize)
Vue.filter('fmtCurrency', fmtCurrency)
Vue.filter('fmtNumber', fmtNumber)
Vue.filter('fmtPercentage', fmtPercentage)
Vue.filter('fmtDateDiff', fmtDateDiff)
Vue.filter('fmtFromNow', fmtFromNow)
Vue.filter('fmtDatesInterval', fmtDatesInterval)
